import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    collpsed: true,
    baseurl: process.env.VUE_APP_BASE_URL,
    pageSize: localStorage.getItem("pageSize") ? Number(localStorage.getItem("pageSize")) : 10,
    content: "",
  },
  mutations: {
    changeCollpsed(state, newvalue) {
      state.collpsed = newvalue
    },
    changePageSize(state, newValue) {
      state.pageSize = newValue
    },
    changeContent(state, newValue) {
      state.content = newValue
    },
  },
  actions: {},
  modules: {},
})
